<template>
  <v-container grid-list-md page>
    <v-flex>
      <h1 class="title primary--text my-3">プレイリスト</h1>
      <profile/>
      <v-layout row wrap mt-3>
        <play-list-a
          :playListCommit="users.playlist_commit"
        />
        <play-list-b/>
      </v-layout>
      <MoreBtnOtherTuneModal v-if="$store.state.moreBtnStore.moreBtnOtherTuneModal === true"></MoreBtnOtherTuneModal>
      <MoreBtnIsumTuneModal v-if="$store.state.moreBtnStore.moreBtnIsumTuneModal === true"></MoreBtnIsumTuneModal>
      <SearchTuneModal v-if="$store.state.searchTuneModal.showFlag === true"></SearchTuneModal>
    </v-flex>
  </v-container>
</template>

<script>
import UserService from '@/components/services/UserService.vue'
import Profile from '@/components/Profile.vue'
import PlayListA from '@/components/PlayListA.vue'
import PlayListB from '@/components/PlayListB.vue'
import SearchTuneModal from '@/components/Organisms/SearchTuneModal.vue'
import MoreBtnOtherTuneModal from '@/components/Organisms/MoreBtnOtherTuneModal.vue'
import MoreBtnIsumTuneModal from '@/components/Organisms/MoreBtnIsumTuneModal.vue'

export default {
  name: 'PlayList',
  components: {
    MoreBtnOtherTuneModal,
    MoreBtnIsumTuneModal,
    PlayListA,
    PlayListB,
    Profile,
    SearchTuneModal
  },
  data () {
    return {
      users: []
    }
  },
  created () {
    this.getCustomerInfo()
    this.$store.dispatch('apiGetFavoriteList', this.$store.state.transactionId)
  },
  methods: {
    /**
     * 新郎新婦情報を取得
     **/
    getCustomerInfo () {
      this.logging('methods: getCustomerInfo')
      let transactionid = this.$store.state.transactionId
      UserService.findCustomer(transactionid, (response) => {
        this.users = response
      }, (error) => {
        this.logging(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/PlayList.vue